import presetTypes, {
    PRESET_TYPE_BRAND,
    PRESET_TYPE_CONDITION_LEVEL
} from "../../../model-constants/product-filter-group/presetTypes";

export default function parseGroupedAttributeIds(groupedAttributeIds) {
    const brandIds = groupedAttributeIds[PRESET_TYPE_BRAND];

    const conditionLevels = groupedAttributeIds[PRESET_TYPE_CONDITION_LEVEL];

    const productAttributeIdLists = Object.keys(groupedAttributeIds)
        .filter(groupId => !presetTypes.values.includes(groupId))
        .map(groupId => groupedAttributeIds[groupId]);

    return {
        brandIds,
        conditionLevels,
        productAttributeIdLists
    };
}
